import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { Observable } from "rxjs";
import { GlossarioOutputDto } from "../domain/DTOs/output/glossario.output.dto";
import { EstruturaRetornoDadosOutputDto } from "../domain/DTOs/output/estrutura-retorno-dados.output.dto";

@Injectable()
export class GlossarioService {

  constructor(private baseService: BaseService) {}

  public obterGlossario(): Observable<EstruturaRetornoDadosOutputDto<GlossarioOutputDto[]>> {
    return this.baseService.get(`Glossario/ObterGlossarioJornal`);
  }
}
